import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { IRowData } from "./TrackOpticsContent/WorkoutAnalysisResults/WorkoutAnalysisTable/WorkoutAnalysisTableRow/WorkoutAnalysisTableRow";
import { transformViewDate } from "utils/date-utils";
import { getPersonFullName, IPerson } from "utils/person";

export const DATE_TIME_FORMAT = "MM/dd/yyyy hh:mm a";
export const CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410 =
  "@media (max-width: 409px)";

export enum EVideoListTab {
  WORKOUTS = "Workouts",
  REVIEWED = "Reviewed"
}

export enum ETouchMoveListenerAction {
  ADD = "Add",
  REMOVE = "Remove"
}

interface VideosTabsStatuses {
  isWorkoutsTabActive: boolean;
  isReviewedTabActive: boolean;
}

export const getGeneralInfoTableData = (
  selectedVideo: racehorse360.ITrackOpticsVideo
): IRowData[] => {
  return [
    {
      label: "Horse Name",
      value: selectedVideo.horseNameOrRegistrationNumber
    },
    {
      label: "Track",
      value: selectedVideo.facility.name
    },
    {
      label: "Work Date / Time",
      value: transformViewDate(selectedVideo.date, null, DATE_TIME_FORMAT)
    }
  ];
};

export const getInjuryReportTableData = (
  selectedVideo: racehorse360.ITrackOpticsVideo
): IRowData[] => {
  const reviewedVet: IPerson = {
    firstName: selectedVideo.injuryReportCreator?.firstName,
    lastName: selectedVideo.injuryReportCreator?.lastName
  };

  return [
    {
      label: "Report Date / Time",
      value: transformViewDate(
        selectedVideo.injuryReportDate?.value,
        null,
        DATE_TIME_FORMAT
      )
    },
    {
      label: "Reviewing Vet",
      value: getPersonFullName(reviewedVet)
    },
    {
      label: "Injury Entry",
      value: selectedVideo.injuryEntry?.description
    },
    {
      label: "Limb",
      value: selectedVideo.limb?.description
    },
    {
      label: "Stride",
      value: selectedVideo.stride?.description
    },
    {
      label: "Severity",
      value:
        selectedVideo.injurySeverity &&
        `${selectedVideo.injurySeverity.value} - ${selectedVideo.injurySeverity.description}`
    },
    {
      label: "Comments",
      value: selectedVideo.comment,
      united: true
    }
  ];
};

export const checkVideosActiveTab = (
  tab: EVideoListTab
): VideosTabsStatuses => ({
  isWorkoutsTabActive: tab === EVideoListTab.WORKOUTS,
  isReviewedTabActive: tab === EVideoListTab.REVIEWED
});

export const setupTouchMoveListener = (
  currentElement: HTMLInputElement,
  action: ETouchMoveListenerAction
): void => {
  const onTouchMove = () => currentElement.blur();

  if (action === ETouchMoveListenerAction.ADD) {
    document.addEventListener("touchmove", onTouchMove);
  } else if (action === ETouchMoveListenerAction.REMOVE) {
    document.removeEventListener("touchmove", onTouchMove);
  }
};
